module.exports = function(title, text){
    var $box = $('#modal-error');
    $box.modal('show') ;
    $box.find('.modal-title').html(title) ;
    $box.find('.modal-body').html(text) ;
    $box.find('.btn').one('click', function() { $box.modal('hide'); }) ;
};